import type React from 'react';
import {TextField} from '@mui/material';

type NumberCellProps = {value: number; min: number; max: number; disabled: boolean; label: string; onCommit: (v: number) => void};

/** A number input that saves on blur or Enter, only when the value changed and is in range. */
export const NumberCell: React.FC<NumberCellProps> = ({value, min, max, disabled, label, onCommit}) => (
    <TextField
        key={value} type="number" size="small" defaultValue={value} disabled={disabled}
        slotProps={{htmlInput: {min, max, step: 1, 'aria-label': label, style: {width: 56, textAlign: 'right'}}}}
        onBlur={e => {
            const v = Number(e.target.value);
            if (Number.isFinite(v) && v >= min && v <= max && v !== value) onCommit(v);
            else e.target.value = String(value);
        }}
        onKeyDown={e => e.key === 'Enter' && (e.target as HTMLInputElement).blur()}
    />
);
